import { createAction, props } from '@ngrx/store';
import { AssignmentApiModel } from 'app/models/assignment-api.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { MwLoadOptions } from 'app/models/load-options.model';

export const loadAssignments = createAction(
  '[Assignments] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadAssignmentsSuccess = createAction(
  '[Assignments] Load Successful',
  props<{ payload: MwPayloadModel<AssignmentApiModel[]> }>()
);

export const loadAssignmentsFailed = createAction(
  '[Assignments] Load Failed',
  props<{ error: any }>()
);

export const createAssignment = createAction(
  '[Assignments] Create',
  props<{ assignment: AssignmentApiModel }>()
);

export const createAssignmentSuccess = createAction(
  '[Assignments] Create Successful',
  props<{ assignment: AssignmentApiModel }>()
);

export const createAssignmentFailed = createAction(
  '[Assignments] Create Failed',
  props<{ error: any }>()
);

export const updateAssignment = createAction(
  '[Assignments] Update',
  props<{ assignment: AssignmentApiModel }>()
);

export const updateAssignmentSuccess = createAction(
  '[Assignments] Update Successful'
);

export const updateAssignmentFailed = createAction(
  '[Assignments] Update Failed',
  props<{ error: any }>()
);

export const deleteAssignment = createAction(
  '[Assignments] Delete',
  props<{ assignment: AssignmentApiModel }>()
);

export const deleteAssignmentSuccess = createAction(
  '[Assignments] Delete Successful'
);

export const deleteAssignmentFailed = createAction(
  '[Assignments] Delete Failed',
  props<{ error: any }>()
);
